export const DESCRIPTION: string =
  'Постарайтесь описать проблему максимально подробно, но при этом тезисно и коротко. От того, насколько понятно и доступно вы напишите свой запрос, зависит скорость его обработки и эффективность предложенных куратором решений. Если описание слишком длинное или сложное, вы можете приложить файл, в котором будут описаны все подробности запроса.';



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/requestform/consts.ts